export default class Footer {
  constructor(element) {
    this.element = element;
    this.yearElements = this.element.querySelectorAll('[data-footer-year]');

    this.init();
  }

  init() {
    this.setCurrentYear();
  }

  setCurrentYear() {
    const currentYear = new Date().getFullYear().toString();

    for (let i = 0; i < this.yearElements.length; i++) {
      this.yearElements[i].textContent = currentYear;
    }
  }
}
